export default __webpack_public_path__ + "assets/googleStore.1d15d39d.png";